import { Component } from '@angular/core';

@Component({
  selector: 'DCO-error',
  templateUrl: './error.component.html',
  standalone: false,
  styleUrls: ['./error.component.css']
})
export class ErrorComponent {

}
